import {Color, ICustomGradient} from '@consts/types'

export const isGradient = (data: Color): data is ICustomGradient => {
  return !!(data as ICustomGradient).points
}